import { JsonObject, JsonProperty } from 'json2typescript';
import { Entity } from './entity';
import { Attachment } from './attachment';
import { DateConverter } from './converters/date-converter';

@JsonObject('Learning')
export class Learning extends Entity {
  @JsonProperty('title', String)
  public title?: string = undefined;
  @JsonProperty('content', String)
  public content?: number = undefined;
  @JsonProperty('complexity', String)
  public complexity?: string = undefined;
  @JsonProperty('machineTypes', [String])
  public machineTypes?: string[] = undefined;
  @JsonProperty('preview', Attachment)
  public preview?: Attachment = undefined;
  @JsonProperty('previewId', String, true)
  public previewId?: string = undefined;
  @JsonProperty('isFavorite', Boolean, true)
  public isFavorite?: boolean = undefined;
  @JsonProperty('active', Boolean, true)
  public active?: boolean = undefined;
  @JsonProperty('tags', [String], true)
  public tags?: string[] = undefined;
  @JsonProperty('language', String, true)
  public language?: string = undefined;

  @JsonProperty('videoPaths', [String], true)
  public videoPaths?: string[] = undefined;
  @JsonProperty('imagePaths', [String], true)
  public imagePaths?: string[] = undefined;
  @JsonProperty('documentPaths', [String], true)
  public documentPaths?: string[] = undefined;

  @JsonProperty('createdDate', DateConverter)
  public createdDate?: Date = undefined;
  @JsonProperty('modifiedDate', DateConverter)
  public modifiedDate?: Date = undefined;
}
